<img (mouseover)="magnify()" [src]="_file" #img crossorigin="anonymous">
